export class Constant {
  public static LOCAL_HOST = 'localhost';
  public static SLASH = '/';
    // public static DOUBLE_SLASH = '//';
    public static BASE_URL = 'https://norwayemb.vowelvms.com/e-visitor-system'; //KK_Ltd
    //public static BASE_URL = 'https://demo.vowelvms.com/e-visitor-system'; //dev server
      //public static BASE_URL = 'http://localhost:9800';
  //public static BASE_URL = 'http://197.220.114.46:8080/e-visitor-system'; //windows server
  //public static BASE_URL = 'http://147.93.84.225:8083/e-visitor-system'; //DHL
  //public static BASE_URL = 'http://localhost:8085/e-visitor-system'; //tomcat url
  //public static BASE_URL = 'http://192.168.100.33:8085/e-visitor-system'; //home server
  //public static BASE_URL = 'https://arcella-1.tail5b8a49.ts.net:8443/e-visitor-system'; //(tailscale)home server

  public static API = "/api";
  public static REST_URL = Constant.BASE_URL + Constant.API;

  public static DAILY_REPORT = "/daily-report";
  public static GET_DAILY_GUEST_REPORT = "/get-daily-guest-report";
  public static SEND_DAILY_GUEST_REPORT = "/send-daily-guest-report";
  public static GET_ALL_HODS = "/get-all-hods";
  public static IMAGES = "/images/";
  public static AUTHENTICATE = "/authenticate";
  public static LOGOUT = "/logout";
  public static ACCOUNT = "/account";
  public static SAVE_ACCOUNT = "/save_account";
  public static REGISTER_ACCOUNT = "/register_account";
  public static USER_GROUP = "/usergroup";
  public static CREATE_USER_GROUP = "/create_user_group";
  public static GET_ALL_USER_GROUP = "/get_all_user_group";
  public static GET_USER_GROUP_BY_ID = "/get_user_group_by_id";
  public static GET_ACCOUNT = "/get_account";
  public static GET_ACCOUNT_BY_ID = "/get_account_by_id";
  public static GET_ALL_ACCOUNT = "/get_all_account";
  public static ACCOUNTCONFIGURATION = "/accountconfiguration";
  public static GET_ALL_FEATURE = "/get_all_feature";
  public static REGISTER_ACCOUNT_CONFIGURATION =
    "/register_account_configuration";
  public static USERMASTER = "/usermaster";
  public static REGISTER_USERMASTER = "/register_usermaster";
  public static GET_ALL_USERMASTER = "/get_all_usermaster";
  public static GET_USERMASTER_BY_ID = "/get_usermaster_by_id";
  public static GET_USER_GROUP = "/get_user_group";
  public static GET_CONFIGURATION_BY_ACCOUNT_ID =
    "/get_configuration_by_account_id";
  public static CREATE_PREMISE_LEVEL = "/create_premise_level";
  public static PREMISE = "/premise";
  public static GET_ALL_PREMSIE_LEVEL = "/get_all_premsie_level";
  public static GET_ALL_USER_GROUP_BY_ACCOUNTID =
    "/get_all_user_group_by_accountId";
  public static GET_CHILD_BY_LEVEL_ID = "/get_child_by_level_id";
  public static CREATE_PREMISE_HIERARCHY = "/create_premise_hierarchy";
  public static GET_ALL_PREMSIE_DETAILS = "/get_all_premsie_details";
  public static GET_PREMISE_DETAILS_BY_ID = "/get_premise_details_by_id";
  public static RESIDENT = "/resident";
  public static REGISTER_RESIDENT = "/register_resident";
  public static GET_ALL_RESIDENT = "/get_all_resident";
  public static GET_RESIDENT_BY_ID = "/get_resident_by_id";
  public static GUEST = "/guest";
  public static GET_ALL_GUEST = "/get_all_guest";
  public static GET_ALL_BOOKED_GUEST = "/get_all_booked_guest";
  public static GET_BASE64_BY_IMAGE_NAME = "/get_base64_by_image_name";
  public static GET_GUEST_BY_ID = "/get_guest_by_id";
  public static BLACKLIST = "/blacklist";
  public static REGISTER_BLACKLIST = "/register_blacklist";
  public static GET_ALL_BLACKLIST_GUEST = "/get_all_blacklist_guest";
  public static FLAG = "/flag";
  public static REGISTER_FLAGGED_VISITOR = "/register_flagged_visitor";
  public static GET_ALL_FLAGGED_GUEST = "/get_all_flagged_guest";
  public static REGISTER_GUEST = "/register_guest";
  public static GET_ALL_RESIDENT_GUEST = "/get_all_resident_guest";
  public static GET_ALL_RECURRENT_GUEST = "/get_all_recurrent_guest";
  public static GET_ALL_TRESPASSER_GUEST = "/get_all_trespasser_guest";
  public static RESIDENT_CHECK_OUT = "/resident_check_out";
  public static RESIDENT_CHECK_OUT_FOR_SP = "/resident_check_out_for_sp";
  public static REGISTER_SERVICE_PROVIDER = "/register_service_provider";
  public static SERVICEPROVIDER = "/serviceprovider";
  public static GET_ALL_EXPECTED_SERVICE_PROVIDER =
    "/get_all_expected_service_provider";
  public static GET_RESIDENT_SERVICE_PROVIDER =
    "/get_resident_service_provider";
  public static GET_SERVICE_PROVIDER_CHECK_IN_CHECK_OUT =
    "/get_service_provider_check_in_check_out";
  public static DASHBOARD = "/dashboard";
  public static GET_SUPERADMIN_DASHBOARD = "/get_superadmin_dashboard";
  public static GET_ACCOUNT_DASHBOARD = "/get_account_dashboard";
  public static GET_RESIDENT_DASHBOARD = "/get_resident_dashboard";
  public static GET_ALL_RESIDENT_LIST = "/get_all_resident_list";
  public static GET_ALL_BLACKLIST = "/get_all_blacklist";
  public static GET_ALL_FLAGGED_LIST = "/get_all_flag_list";
  public static GET_ALL_TRESPASSER_SERVICE_PROVIDER =
    "/get_all_trespasser_service_provider";
  public static GET_ALL_RECURRENT_SP = "/get_all_recurrent_sp";
  public static GET_USER_LIST = "/get_user_list";
  public static AUDTI = "/audit";
  public static GET_ALL_AUDIT_TRAIL = "/get_all_audit_trail";
  public static REGISTER_STAFF = "/register_staff";
  public static STAFF = "/staff";
  public static GET_ALL_STAFF = "/get_all_staff";
  public static GET_STAFF_BY_ID = "/get_staff_by_id";
  public static GET_STAFF_CHECK_IN = "/get_staff_check_in";
  public static GET_STAFF_CHECK_IN_BY_RESIDENT =
    "/get_staff_check_in_by_resident";
  public static GET_RIGHTS = "/get_rights";
  public static GET_USER_DETAILS = "/get_user_details";
  public static GET_RIGHTS_BY_USERNAME = "/get_rights_by_username";
  public static EXITED_VISITOR_REPORT = "/exited_visitor_report";
  public static NOTIFICATION = "/notification";
  public static GET_ALL_NOTIFICATION = "/get_all_notification";
  public static CHANGE_NOTIFICATION_STATUS = "/change_notification_status";
  public static CREATE_PROPERTY_TYPE = "/create_property_type";
  public static GET_ALL_PROPERTY_TYPE = "/get_all_property_type";
  public static ADD_RESIDENT_FAMILY = "/add_resident_family";
  public static GET_RESIDENT_BY_FLAT_ID = "/get_resident_by_flat_id";
  public static CHANGE_PASSWORD = "/change-password";
  public static IMPORT_RESIDENT = "/import_resident";
  public static GET_FILE = "/get_file";
  public static GET_VEHICLE_FILE = "/get_vehicle_file";
  public static GET_ACCOUNT_LOGO = "/get_account_logo";
  public static DOWNLOAD_SAMPLE_SHEET = "/download_sample_sheet";
  public static GET_SP_BY_ID = "/get_sp_by_id";
  public static GET_ALL_RESIDENT_FLAGGED_LIST = "/get_all_resident_flag_list";
  public static GET_RESIDENT_FAMILY = "/get_resident_family";
  public static CAPTURE_IMAGE = "/capture_image";
  public static GET_RECALL_GUEST_BY_ID = "/get_recall_guest_by_id";
  public static GET_DIALING_CODE_LIST = "/get_dialing_code_list";
  public static DELETE_PREMISE_LEVEL = "/delete_premise_level";
  public static GET_PROPERTY_TYPE_LIST = "/get_property_type_list";
  public static GET_COUNTY_BY_ID = "/get_county_by_id";
  public static GET_COUNTY_LIST = "/get_county_list";
  public static REGISTER_COUNTY = "/register_county";
  public static GET_PROFILE_LIST = "/get_profile_list";
  public static GET_ALL_REJECTED_VISITOR = "/get_all_rejected_visitor";
  public static GET_COMPANY_LIST = "/get_company_list";
  public static REGISTER_FIELD_CONFIGURATION = "/register_field_configuration";
  public static GET_FIELD_CONFIGURATION = "/get_field_configuration";
  public static IMPORT_RESIDENT_FAMILY = "/import_resident_family";
  public static IMPORT_STAFF = "/import_staff";
  public static IMPORT_COMMERCIAL_VEHICLE = "/import_commercial_vehicle";
  public static REPORT = "/report";
  public static EXITED_REPORT_AS_PDF = "/exited_report_as_pdf";
  public static EXITED_REPORT_AS_EXCEL = "/exited_report_as_excel";
  public static EXPORT_AUDIT_TRAIL = "/export_audit_trail";
  public static EMPLOYEE = "/employee";
  public static REGISTER_EMPLOYEE = "/register_employee";
  public static GET_ALL_EMPLOYEE = "/get_all_employee";
  public static GET_EMPLOYEE_BY_ID = "/get_employee_by_id";
  public static REGISTER_COMMERCIAL_GUEST = "/register_commercial_guest";
  public static GET_ALL_EMPLOYEE_GUEST = "/get_all_employee_guest";
  public static GET_ALL_COMMERCIAL_BOOKED_GUEST =
    "/get_all_commercial_booked_guest";
  public static GET_ALL_COMMERCIAL_GUEST = "/get_all_commercial_guest";
  public static GET_ALL_COMMERCIAL_RECURRENT_GUEST =
    "/get_all_commercial_recurrent_guest";
  public static GET_DEVICE_LIST = "/get_device_list";
  public static IMPORT_EMPLOYEE = "/import_employee";
  public static IMPORT_GUEST = "/import_guest";
  public static IMPORT_GUEST_TEMPLATE = "/import_guest_template";
  public static GET_EMPLOYEE_DASHBOARD = "/get_employee_dashboard";
  public static GET_COMMERCIAL_NOTIFICATION = "/get_commercial_notification";
  public static GET_ALL_STAFF_NOTIFICATION = "/get_all_staff_notification";
  public static CHECK_PREMISE_AVAILABILITY_FOR_RESIDENT =
    "/check_premise_availability_for_resident";
  public static GET_ACCOUNT_ADDRESS = "/get_account_address";
  public static DELETE_FLAT = "/delete_flat";
  public static REGENERATE_RESIDENT_QRCODE = "/regenerate_resident_qrcode";
  public static GET_STAFF_QR_IMAGE = "/get_staff_qr_image";
  public static GET_VISITOR_GRAPHICAL_REPORT = "/get_visitor_graphical_report";
  public static GET_VISITOR_BAR_CHRT = "/get_visitor_bar_chrt";
  public static GET_VEHICLE_GRAPHICAL_REPORT = "/get_vehicle_graphical_report";
  public static REGENERATE_STAFF_QRCODE = "/regenerate_staff_qrcode";
  public static CHECK_STAFF_QR_EXPIRE = "/check_staff_qr_expire";
  public static GET_RESIDENT_QR_IMAGE = "/get_resident_qr_image";
  public static CHECK_RESIDENT_QR_EXPIRE = "/check_resident_qr_expire";
  public static RESET_PASSWORD = "/reset_password";
  public static GET_PASSWORD_RESET_REQUEST = "/get_password_reset_request";
  public static CHANGED_PASSWORD = "/change_password";
  public static CHECK_LINK_EXPIRE = "/check_link_expire";
  public static GENERATE_PASSWORD_LINK = "/generate_password_link";
  public static CHECK_IN_CHECK_OUT = "/check_in_check_out";
  public static GET_VISITOR_BY_QR_CODE = "/get_visitor_by_qr_code";
  public static SEND_NOTIFICATION = "/send_notification";
  public static GET_GUEST_CHECK_IN_CHECK_OUT = "/get_guest_check_in_check_out";
  public static SERVICE_PROVIDER_CHECK_IN_CHECK_OUT =
    "/service_provider_check_in_check_out";
  public static GET_DEVICE_NOTIFICATION = "/get_device_notification";
  public static GET_STAFF_LIST = "/get_staff_list";
  public static GET_COMMERCIAL_GUEST_CHECK_IN_CHECK_OUT =
    "/get_commercial_guest_check_in_check_out";
  public static SEND_COMMERCIAL_NOTIFICATION = "/send_commercial_notification";
  public static GET_ALL_PLAN_MASTER = "/get_all_plan_master";
  public static CREATE_PLAN_MASTER = "/create_plan_master";
  public static GET_PLAN_BY_ID = "/get_plan_by_id";
  public static GET_PLAN_LIST = "/get_plan_list";
  public static RENEW_PLAN = "/renew_plan";
  public static GET_PLAN_VALIDITY = "/get_plan_validity";
  public static GET_VISITOR_COUNT = "/get_visitor_count";
  public static SUPEROWNER = "/superowner";
  public static GET_ALL_SO_REQUEST = "/get_all_superowner_request";
  public static CHANGE_STATUS = "/change_status";
  public static CREATE_SUPEROWNER_REQUEST = "/create_superowner_request";
  public static GET_VISITOR_INFO = "/get_visitor_info";
  public static GET_RECURRENT_VISITOR_DETAILS =
    "/get_recurrent_visitor_details";
  public static GET_RECURRENT_SP_DETAILS = "/get_recurrent_sp_details";
  public static VISITOR_VEHICLE_REPORT = "/visitor_vehicle_report";
  public static EXPORT_VEHICLE_REPORT = "/export_vehicle_report";
  public static GET_FIELD_CONFIGURATION_FOR_MOBILE =
    "/get_field_configuration_for_mobile";
  public static REGENERATE_GUEST_QRCODE = "/regenerate_guest_qrcode";
  public static GET_HOST_RECURRENT_GUEST = "/get_host_recurrent_guest";
  public static GENERATE_VISITOR_QRCODE = "/generate_visitor_qrcode";
  public static GET_HOST_RECURRENT_SP = "/get_host_recurrent_sp";
  public static SEND_VISITOR_QR_INVITATION = "/send_visitor_qr_invitation";
  public static GET_RESIDENT_CHECK_IN = "/get_resident_check_in";
  public static SELFSERVICE = "/selfservice";
  public static GENERATE_SERVICE_LINK = "/generate_service_link";
  public static GET_SERVICE_LINK_LIST = "/get_service_link_list";
  public static CREATE_SELF_GUEST = "/create_self_guest";
  public static GET_ALL_SELF_GUEST = "/get_all_self_guest";
  public static CHANGE_SELF_GUEST_STATUS = "/change_self_guest_status";
  public static UPDATE_USER_PROFILE = "/update_profile";
  public static ENABLE_DEVICE_NOTIFICATION = "/enable_device_notification";
  public static GET_PANIC_NOTIFICATION = "/get_panic_notification";
  public static GET_ACCOUNT_OCR_KEY = "/get_account_ocr_key";
  public static REGISTER_OCR_KEY = "/register_ocr_key";
  public static GET_ALL_FLAT_LIST = "/get_all_flat_list";
  public static SEND_PANIC_NOTIFICATION = "/send_panic_notification";
  public static GET_CURRENT_VISITOR__SERVICE_PROVIDER_BAR_CHART =
    "/get_current_visitor__service_provider_bar_chart";
  public static GET_PANIC_NOTIFICATION_COUNT = "/get_panic_notification_count";
  public static CHANGE_PANIC_NOTIFICATION_STATUS =
    "/change_status_panic_notifiaction";
  public static REGISTER_VEHICLE = "/register_vehicle";
  public static REGISTER_COMMERCIAL_VEHICLE = "/register_commercial_vehicle";
  public static GET_VEHICLE_LIST = "/get_vehicle_list";
  public static DELETE_VEHICLE_INFO = "/delete_vehicle_info";
  public static GET_DEVICE_USER_LIST = "/get_device_user_list";
  public static CREATE_ENTRY_POINT = "/create_entry_point";
  public static GET_ALL_ENTRY_POINT = "/get_all_entry_point";
  public static DELETE_ENTRY_POINT = "/delete_entry_point";
  public static GET_ALL_GATE = "/get_all_gate";
  public static CREATE_GATE_MASTER = "/create_gate_master";
  public static DELETE_GATE_MASTER = "/delete_gate_master";
  public static REGENERATE_COMMERCIAL_VEHICLE_QRCODE =
    "/regenerate_commercial_vehicle_qrcode";
  public static GET_COMMERCIAL_VEHICLE_LIST = "/get_commercial_vehicle_list";
  public static GET_ALL_COMMERCIAL_VEHICLE = "/get_all_commercial_vehicle";
  public static CHECK_IN_CHECK_OUT_COMMERCIAL_VEHICLE =
    "/check_in_check_out_commercial_vehicle";
  public static GET_COMMERCIAL_VEHICLE_CHECK_IN =
    "/get_commercial_vehicle_check_in";
  public static GET_ALL_EXPECTED_SCRAP_VEHICLE_NO =
    "/get_all_expected_scrap_vehicle_no";
  public static SCRAP_AGENT = "/scrap_agent";
  public static GET_SCRAP_AGENT_LIST = "/get_scrap_agent_list";
  public static REGISTER_SCRAP_AGENT_DETAILS = "/register_scrap_agent_details";
  public static DELETE_SCRAP_AGENT_INFO = "/delete_scrap_agent_info";
  public static GET_ALL_SCRAP_AGENT_NAME = "/get_all_scrap_agent_name";
  public static GET_COMPANY_LIST_BY_CONTRACTOR_TYPE =
    "/get_company_list_by_contractor_type";
  public static GENERATE_SERVICE_PROVIDER_QRCODE =
    "/generate_service_provider_qrcode";
  public static ONBOARDING = "/onboarding";
  public static GENERATE_ONBOARDING_QR = "/generate_qr";
  public static REDEEM_ONBOARDING_QR = "/redeem";
  public static BOUND_DEVICE = "/bound-device";
  public static GET_ELIGIBLE_USERS = "/get-eligible-users";
  public static GRANT_ACCESS = "/grant-access";
  public static GRANT_ACCESS_BULK = "/grant-access-bulk";
  public static REVOKE_ACCESS = "/revoke-access";
  public static REVOKE_ACCESS_BULK = "/revoke-access-bulk";
  public static TOTAL_BOUND = "/total-bound";
  public static MOBILE_BINDING_LICENSE = "/mobile-binding-license";
  public static REGISTRATION_CODE = "/registration-code";
  public static GENERATE_REGISTRATION_CODE = "/generate";
  public static VALIDATE_REGISTRATION_CODE = "/validate";
  public static GET_REGISTRATION_CODE_LIST = "/list";
  public static REGISTRATION_REQUEST = "/registration-request";
  public static SUBMIT_REGISTRATION_REQUEST = "/submit";
  public static GET_PENDING_REGISTRATION_REQUESTS = "/pending";
  public static GET_ALL_REGISTRATION_REQUESTS = "/all";
  public static APPROVE_REGISTRATION_REQUEST = "/approve";
  public static APPROVE_ALL_REGISTRATION_REQUESTS = "/approve-all";
  public static REJECT_REGISTRATION_REQUEST = "/reject";
  public static SYSTEM_NOTIFICATION = "/system_notification";
  public static SEND_SYSTEM_NOTIFICATION = "/send";
  public static GET_ALL_SYSTEM_NOTIFICATION = "/get_all";
  public static SAVE_SYSTEM_NOTIFICATION = "/save";
  public static GET_RECIPIENTS = "/get_recipients";
}
